import { useState, useEffect,useRef } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaDownload } from "react-icons/fa6";
import logo from '../../../assets/star.jpg';
import mammoth from "mammoth";
import "react-quill/dist/quill.snow.css";
import { MdDeleteForever } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';
import CreatableSelect from "react-select/creatable";
import { BiMessageAltMinus } from "react-icons/bi";
  import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import socket from "../../../socket";

const Warranty = ({ branchID, adminData ,companyID,  financialYear}) => {
 const searchInputRef = useRef(null);

  const location = useLocation();
    const mode = location.state?.mode;
    const partyId = location.state?.partyId;
    const editData = location.state?.data;
    
  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);
  const [content, setContent] = useState("");

  const getCurrentDateTime = () => {
    const now = new Date();

    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const year = istTime.getFullYear();
    const month = String(istTime.getMonth() + 1).padStart(2, "0");
    const day = String(istTime.getDate()).padStart(2, "0");
    const hours = String(istTime.getHours()).padStart(2, "0");
    const minutes = String(istTime.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };


  const [formItems, setFormItems] = useState({
    ref_doc: '',
    party: '',
    sale_person: '',
    technician: '',
    created_date: getCurrentDateTime(),
    start_date: '',
    end_date: '',
    total: '',
    frequency: null,
    warranty_type: null,
    remark: '',
    type_acc: ''
  })

  const [files, setFiles] = useState({
    file: null,

  })
  const [formData, setFormData] = useState([]);

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const [search, setSearch] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [partyOptions, setPartyOptions] = useState([]);
  const [detail, setDetail] = useState([]);
  const [user, setUser] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [quotation, setQuotation] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isInitialEditLoad, setIsInitialEditLoad] = useState(false);
  const [branchDetail, setBranchDetail] = useState([])
  const [refDocs, setRefDocs] = useState([]);
  const [allSaleInvoices, setAllSaleInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
 
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const [fetchWarranty, setFetchWaranty] = useState([]);
  const [grandTotalState, setGrandTotalState] = useState(0);
  const [pmsSchedule, setPmsSchedule] = useState([]);
const [showWarrantyModal, setShowWarrantyModal] = useState(false);
 const [selectedWarranty, setSelectedWarranty] = useState(null);
  const [serialsByItem, setSerialsByItem] = useState({});
  const [serialError, setSerialError] = useState({});
 const[company,setCompany] = useState([]);

  const [offset, setOffset] = useState(0);
              const limit = 20;
              const [hasMore, setHasMore] = useState(true);
              const [fromDate, setFromDate] = useState();
              const [toDate, setToDate] = useState();
              const [isLocked, setIsLocked] = useState(false);
              const [fy, setFy] = useState([]);


               useEffect(() => {
                                    if (showPartyModal) {
                                      setTimeout(() => {
                                        searchInputRef.current?.focus();
                                      }, 100);
                                    }
                                  }, [showPartyModal]);
          
              const [financialRange, setFinancialRange] = useState({
                  from_date: '',
                  to_date: ''
              });

  useEffect(() => {
            if (mode === "edit" && editData) {
                handleEdit(editData);   
            }
        }, [editData, mode]);


    useEffect(() => {
      if (!branchDetail?.code) return;
    
      socket.on("new-warranty", (data) => {
    
    
        if (data.branch === branchDetail.code) {
          showToast(data.message, "info");
        }
      });
    
      return () => socket.off("new-warranty");
    }, [branchDetail]);
        


  const frequencyOptions = [
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "half-yearly", label: "Half Yearly" },
    { value: "bi-monthly", label: "Bi Monthly" },
    { value: "four-monthly", label: "Four Monthly" },
  ];


  const [typeOptions, setTypeOptions] = useState([
    "Comprehensive",
    "Non-Comprehensive",
  ]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFrequencyChange = (option) => {
    setFormItems(prev => ({
      ...prev,
      frequency: option.value
    }));
  };

  const handleTypeSelect = (e) => {
    const value = e.target.value;

    if (value === "__add_new_type__") {
      setShowTypeModal(true);
      return;
    }

    let remarkText = "";

    if (value === "Comprehensive") {
      remarkText = "This service includes comprehensive warranty coverage.";
    } else if (value === "Non-Comprehensive") {
      remarkText = "This service includes non-comprehensive warranty coverage.";
    }

    setFormItems(prev => ({
      ...prev,
      warranty_type: value,
      remark: remarkText
    }));
  };




  const handleAddClick = () => {
    setShowForm(true);
  }


  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    const fieldName = e.target.name;


    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes → MB
      if (fileSizeInMB > 2) {
        setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
        return;
      }
      setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
    }

    if (fieldName === "customLetter") {
      if (!file.name.endsWith(".docx")) {
        setToast("Please upload a .docx file for Custom Letter", "danger");
        return;
      }

      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });

      // Set ReactQuill content
      setContent(result.value);
    }


  };

  const handleSelectChange = (e) => {
    const id = e.target.value;
    if (!id) return;


    const selectedItem = items.find((i) => i.id == id);

    if (!selectedItem) return;


    setFormData((prev) => [
      ...prev,
      {
        id: selectedItem.id,
        name: selectedItem.name,
        qty: 0,
        rate: selectedItem.rate || 0,
        gst: "",
        amount: "",
        tax: selectedItem.tax || "",
        sr_no: '',
        install: ''
      },
    ]);
  };

  const filtered = partyOptions.filter(
    (p) =>
      p.label.toLowerCase().includes(search.toLowerCase()) ||
      (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
      (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  );




  const handleFormItemChange = (index, field, value) => {
    const updated = [...formData];
    updated[index] = {
      ...updated[index],
      [field]: value
    };

    const qty = parseFloat(updated[index].qty) || 0;
    const rate = parseFloat(updated[index].rate) || 0;
    const tax = parseFloat(updated[index].tax) || 0;

    const baseAmount = qty * rate;
    const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
    const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

    updated[index].baseAmount = baseAmount;
    updated[index].taxAmount = taxAmount;
    updated[index].amount = totalAmount;


     if ((field === "id" || field === "qty") && updated[index].id && qty > 0) {
      fetchSerials(updated[index].id, qty);
    }


    setFormData(updated);

    // Always recalc subtotals and GST
    const subTotal = updated.reduce((sum, item) => sum + (item.baseAmount || 0), 0);
    const totalGst = updated.reduce((sum, item) => sum + (item.taxAmount || 0), 0);

    const chargesTotal = (formItems?.additionalDetails ?? []).reduce(
      (sum, item) => sum + (Number(item.value2) || 0),
      0
    );

    let grandTotalCalc = 0;

    if (isEditMode) {
      // Use stored total in edit mode
      grandTotalCalc = parseFloat(formItems.total) || 0;
    } else {
      // Recalculate in create mode
      grandTotalCalc =
        updated.reduce((sum, item) => sum + (Number(item.amount) || 0), 0) +
        chargesTotal;
    }

    setSubTotal(subTotal.toFixed(2));
    setTotalTax(totalGst.toFixed(2));
    setGrandTotal(grandTotalCalc.toFixed(2));
  };


  const handleDeleteItem = (indexToRemove) => {
    const newItems = formData.filter((_, idx) => idx !== indexToRemove);

    const currentExtra = formItems.additionalDetails || [];


    recalcTotals(newItems, currentExtra);


    setFormData(newItems);
  };



  const handleSelectDoc = (selectedOption) => {
    if (!selectedOption) return;

    // Update selected option state
    setSelectedDoc(selectedOption);

    const selectedInvoice = allSaleInvoices.find(
      inv =>
        (inv.ref_doc_sq && String(inv.ref_doc_sq) === String(selectedOption.value)) ||
        (inv.ref_doc && !inv.ref_doc_sq && String(inv.ref_doc) === String(selectedOption.value))
    );

    if (!selectedInvoice) {
      console.warn("Invoice not found for:", selectedOption.value);
      return;
    }

    // Parse additional charges
    const additionalDetails = selectedInvoice.additional_charges
      ? JSON.parse(selectedInvoice.additional_charges).map(c => ({
        ...c,
        value2: Number(c.value2) || 0
      }))
      : [];

    // Parse items
    let itemsData = [];
    try {
      itemsData = JSON.parse(selectedInvoice.items || "[]").map(item => {
        const qty = Number(item.qty) || 0;
        const rate = Number(item.rate) || 0;
        const tax = Number(item.tax) || 0;
        const baseAmount = qty * rate;
        const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
        const amount = parseFloat((baseAmount + taxAmount).toFixed(2));
        return { ...item, qty, rate, tax, baseAmount, taxAmount, amount };
      });
    } catch (err) {
      console.error("Error parsing items JSON:", err);
    }

    // Totals
    const subTotal = itemsData.reduce((sum, i) => sum + i.baseAmount, 0);
    const totalGst = itemsData.reduce((sum, i) => sum + i.taxAmount, 0);
    const chargesTotal = additionalDetails.reduce(
      (sum, c) => (c.type?.toLowerCase() === "discount" ? sum - c.value2 : sum + c.value2),
      0
    );
    const grandTotal = subTotal + totalGst + chargesTotal;

    setFormItems(prev => ({
      ...prev,
      // ref_doc: selectedInvoice.ref_doc_sq ?? selectedInvoice.ref_doc,
      // ref_doc_sq: selectedInvoice.ref_doc_sq || null,

      ref_doc: selectedOption.value,
      ref_doc_sq: selectedOption.ref_doc_sq || null,


      // party: selectedInvoice.party,
      // partyName: selectedInvoice.party_name,
      cust_enq: selectedInvoice.cust_enq,
      quotation_date: selectedInvoice.quotation_date,
      sale_person: selectedInvoice.sale_person,
      technician: selectedInvoice.technician,
      description: selectedInvoice.description,
      remark: selectedInvoice.remark,
      file: selectedInvoice.file,
      additionalDetails,
      grandTotal
    }));

    setFormData(itemsData);
      itemsData.forEach(item => {
        if (item.id && item.qty > 0) {
          fetchSerials(item.id, item.qty);
        }
      });
    setSubTotal(subTotal);
    setTotalTax(totalGst);
    setGrandTotal(grandTotal);
  };

  const recalcTotals = (items = [], extraRows = []) => {

    const updatedItems = Array.isArray(items) ? items : [];
    const updatedExtra = Array.isArray(extraRows) ? extraRows : [];


    const subTotal = updatedItems.reduce(
      (sum, item) => sum + (Number(item.baseAmount) || 0),
      0
    );

    const totalGst = updatedItems.reduce(
      (sum, item) => sum + (Number(item.taxAmount) || 0),
      0
    );

    // Calculate extra charges / discounts
    const chargesTotal = updatedExtra.reduce((sum, item) => {
      const value = Number(item.value2) || 0;
      return item.type?.toLowerCase() === "discount" ? sum - value : sum + value;
    }, 0);


    const grandTotal = subTotal + totalGst + chargesTotal;

    // Update state
    setSubTotal(subTotal.toFixed(2));
    setTotalTax(totalGst.toFixed(2));
    setGrandTotal(grandTotal.toFixed(2));
  };


  useEffect(() => {
    if (isEditMode) {
      setTimeout(() => setIsInitialEditLoad(false), 0);
    }
  }, [formData]);

  const fecthDetail = async () => {
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];
      setItems(items);
    } catch (error) {
      console.log(error)
    }
  };

  const fetchPartyDetail = async () => {
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phone: p.phone,
        address: p.address,
        phone: p.phone || "",
        mobile: p.mobile || "",
        phone_two: p.phone_two || "",
        phone_three: p.phone_three || "",

      }));

      const data = resParty.data;

      setDetail(data);

      setPartyOptions(options);

    } catch (error) {
      console.log(error);
    }
  };

  const fectEmphDetail = async () => {
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
         const filtered = (resEmployee.data.result || []).filter(
      emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
    );

    setUser(filtered);


    } catch (error) {
      console.log(error)
    }
  };

   const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

        const fetchYearDetail = async () => {
                        setLoading(true);
                        try {
                            const branchCode = await fetchBranchDetail();
                            const res = await axios.get(
                                `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                            );
                            const yearData = res.data;
                            setFy(yearData);
                            setIsLocked(yearData.is_locked === 1);
                            setFinancialRange({
                                from_date: yearData.from_date,
                                to_date: yearData.to_date
                            });
                
                            await warrantyDetail(
                                yearData.from_date,
                                yearData.to_date,
                                branchCode,
                
                            );
                        } catch (error) {
                            console.log(error);
                        } finally {
                            setLoading(false);
                        }
                    };
    

  const fetchSaleInvoice = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://api.skyguard.group/api/fetch-sale-invoice"
      );

      const saleInvoices = response.data.filter(
        item => item.type_acc === "sale_invoice"
      );

      // console.log(saleInvoices);

      setAllSaleInvoices(saleInvoices);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const warrantyDetail = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {
    setLoading(true);

     if (!branchCode) {
            console.log("Branch code missing");
            return;
        }

    try {
      const response = await axios.get(
        "https://api.skyguard.group/api/fetch-warranty",
        {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        branch_code: branchCode,
                        limit: limit,
                        offset: newOffset
                    }
                }
      );

 
      const filterWarranty = response.data.filter(r => r.type_acc === 'warranty')
      // setFetchWaranty(filterWarranty);


const result = filterWarranty
            if (newOffset === 0) {
                setFetchWaranty(result);
                setHasMore(true);
            }

            else {
                setFetchWaranty(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            // check if more data exists
            if (result.length < limit) {
                setHasMore(false);
            }

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


    const fetchSerials = async (inventoryId, qty) => {
      if (!inventoryId) return;
  
      try {
        const res = await axios.get(
          "https://api.skyguard.group/api/fetch-inventory-serials",
          { params: { inventory_id: inventoryId } }
        );
  
        const flattened = Array.isArray(res.data[0]) ? res.data.flat() : res.data;
  
  
        const unsoldSerials = Array.from(
          new Map(flattened.map(s => [s.id, s])).values()
        ).filter(s => !s.sold_on || s.sold_on === 0);
  
        setSerialsByItem(prev => ({
          ...prev,
          [inventoryId]: unsoldSerials
        }));
  
  
        if (qty > unsoldSerials.length) {
          setSerialError(prev => ({
            ...prev,
            [inventoryId]: `Not enough serial numbers .`
          }));
        } else {
          setSerialError(prev => ({
            ...prev,
            [inventoryId]: null
          }));
        }
  
  
  
      } catch (err) {
        console.error("Error fetching serials:", err);
      }
    };
  

  const getSerialNumbers = (inventory_id, qty) => {
    if (!inventory_id || !qty) return [];

    const list = serialsByItem[inventory_id] || [];

    
    return list.slice(0, qty).map(s => s.sr_no);
  };



const hasFetched = useRef(false);


   const fetchCompany = async () => {
          setLoading(true)
        try {
          const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
          setCompany(res.data);
    
        } catch (error) {
          console.log(error)
        } finally {
         setLoading(false);
            }
      };
    
useEffect(() => {
  if (hasFetched.current) return;
  hasFetched.current = true;

  fecthDetail();
  fetchPartyDetail();
  fectEmphDetail();
  fetchBranchDetail();
  fetchSaleInvoice();
 fetchYearDetail();
  fetchSerials();
  fetchCompany();
}, []);




  const handleUpdate = async (e) => {
    e.preventDefault();

    const sendData = new FormData();
    const safe = (v) => (v === undefined || v === null ? "" : v);

    sendData.append("type_acc", 'warranty');

    sendData.append("ref_doc", formItems.ref_doc);
    sendData.append("party", formItems.party);
    sendData.append("sale_person", formItems.sale_person);
    sendData.append("technician", formItems.technician);
    sendData.append('branch', branchDetail.code)

    sendData.append(
      "created_date",
      formItems.created_date
        ? formItems.created_date.replace("T", " ")
        : ''
    );

    sendData.append(
      "start_date",
      formItems.start_date
        ? formItems.start_date.replace("T", " ")
        : ""
    );

    sendData.append(
      "end_date",
      formItems.end_date
        ? formItems.end_date.replace("T", " ")
        : ""
    );



    sendData.append(
      "items",
      JSON.stringify(
        (formData || []).map((item) => {
          const qty = parseFloat(item.qty) || 0;
          const rate = parseFloat(item.rate) || 0;
          const tax = parseFloat(item.tax) || 0;
          const baseAmount = qty * rate;
          const gstAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
          const amount = parseFloat((baseAmount + gstAmount).toFixed(2));

          return {
            id: item.id || null,
            name: item.name,
            qty,
            rate,
            tax,
            gst_amount: gstAmount,
            base_amount: baseAmount,
            amount,
            sr_no: item.sr_no || "",
            install: item.install || "",
          };
        })
      )
    );
    sendData.append("total", grandTotal);
    sendData.append("frequency", formItems.frequency);
    sendData.append("warranty_type", safe(formItems.warranty_type));

    sendData.append("remark", safe(formItems.remark));
    if (files.file) sendData.append("file", files.file);


    const startDate = formItems.start_date;
    const endDate = formItems.end_date;
    const frequency = formItems.frequency;

    if (startDate && endDate && frequency) {
      const schedule = generatePMSchedule(startDate, endDate, frequency);


      setPmsSchedule(schedule);


      sendData.append("pms_schedule", JSON.stringify(schedule));
    }

    try {
      let res;

      if (isEditMode && editingCompanyId) {
        sendData.append("edit_by", adminData.user.id);

        res = await axios.put(
          `https://api.skyguard.group/api/update-warranty/${editingCompanyId}`,
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("Warranty Updated Successfully!", "success");
        warrantyDetail(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
      } else {
        sendData.append("added_by", adminData.user.id);

        res = await axios.post(
          "https://api.skyguard.group/api/add-warranty",
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("Warranty Added Successfully!", "success");
        warrantyDetail(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
      }
      const startDate = formItems.start_date;
      const endDate = formItems.end_date;
      const frequency = formItems.frequency;

      if (startDate && endDate && frequency) {
        const schedule = generatePMSchedule(startDate, endDate, frequency);
        setPmsSchedule(schedule);
      }


      resetForm();
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast(
        isEditMode ? "Failed to update!" : "Failed to create!",
        "danger"
      );
    }
  };


  const resetForm = () => {
    setFormItems({
      party: "",
      cust_enq: "",
      quotation_date: getCurrentDateTime(),
      sale_person: "",
      technician: "",
      grand_total: "",
      total_gst: "",
      sub_total: "",
      remark: "",
      description: "",
      ref_doc: "",
      type_acc: "",
      subject: '',
      customLetter: null,
    });

    setFormData([]);
    setSelectedDoc(null);
    setSelectedParty(null);
    setSubTotal("0.00");
    setTotalTax("0.00");
    setGrandTotal("0.00");
    setFiles({});
    setShowForm(false);
    setContent("");
    setPmsSchedule([]);
    setRefDocs([]);
  };

  useEffect(() => {
    if (isEditMode && formItems.ref_doc === null && refDocs.length && editingCompanyId) {
   
      const selected = refDocs.find(
        opt => String(opt.value) === String(formItems.ref_doc)
      );

      if (selected) {
        setFormItems(prev => ({
          ...prev,
          ref_doc: selected
        }));
      }
    }
  }, [refDocs, isEditMode]);



  useEffect(() => {
    if (isEditMode) {
      setGrandTotalState(parseFloat(formItems.total) || 0);
    } else {
      const total = formData.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );
      setGrandTotalState(total);
    }
    // ⚠ Only recalc when formData changes in add mode
  }, [isEditMode, formItems.total, ...(isEditMode ? [] : [formData])]);



  const handleEdit = (form) => {
 console.log(form)

    let parsedItems = [];
    try {
      parsedItems = JSON.parse(form.items || "[]");
    } catch (err) {
      console.log("Invalid JSON for items:", err);
    }

    let parsedPms = [];
    try {
      parsedPms = JSON.parse(form.pms_schedule || "[]");
    } catch (err) {
      console.log("Invalid JSON for pms_schedule:", err);
    }
    setPmsSchedule(parsedPms);

    const filteredInvoices = allSaleInvoices.filter(
      inv => String(inv.party) === String(form.party)
    );

    const refDocsForParty = filteredInvoices.map(q => ({
      value: q.ref_doc_sq || q.ref_doc,
      label: q.inv_no
        ? `SL: ${q.inv_no}`
        : `SL: ${q.ref_doc_sq || q.ref_doc}`,
      ref_doc: q.ref_doc,
      ref_doc_sq: q.ref_doc_sq || null
    }));

    setRefDocs(refDocsForParty);

    // // ✅ set selectedDoc for react-select
    // ✅ correct
    const selectedRefDoc = refDocsForParty.find(
      doc => doc.value === (form.ref_doc_sq || form.ref_doc)
    );
    setSelectedDoc(selectedRefDoc || null);





    setFormItems({
      id: form.id || "",
      party: form.party || "",
      partyName: form.party_name || "",
      ref_doc: form.ref_doc || '',
      sale_person: form.sale_person || "",
      technician: form.technician || "",
      created_date: form.created_date || "",
      start_date: form.start_date || '',
      end_date: form.end_date || '',
      total: form.total || "",
      frequency: form.frequency || "",
      warranty_type: form.warranty_type || "",
      remark: form.remark || "",
      party_add: form.party_address || "",
      created_date:form.created_date || "",
    });

    setFormData(parsedItems);
    setFiles({ file: form.file || null });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const generatePMSchedule = (startDate, endDate, frequency) => {
    const schedule = [];
    let current = new Date(startDate);
    const end = new Date(endDate);
    let pmsNo = 1;

    const addMonths = (date, months) => {
      const d = new Date(date);
      d.setMonth(d.getMonth() + months);
      return d;
    };

    let increment = 1;
    switch (frequency) {
      case "monthly":
        increment = 1;
        break;
      case "bi-monthly":
        increment = 2;
        break;
      case "quarterly":
        increment = 3;
        break;
      case "four-monthly":
        increment = 4;
        break;
      case "half-yearly":
        increment = 6;
        break;
      default:
        increment = 1;
    }

    while (current <= end) {
      schedule.push({
        pmsNo: pmsNo++,
        dueDate: current.toISOString().split("T")[0],
        completionDate: ""
      });
      current = addMonths(current, increment);
    }

    return schedule;
  };

   const filteredData = fetchWarranty.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );





const downloadWarrantyPDF = async () => {
  const element = document.getElementById("warranty-letter");

  // Hide the footer temporarily
  const footer = element.querySelector(".no-print");
  if (footer) footer.style.display = "none";

  try {
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("warranty-letter.pdf");
  } catch (err) {
    console.error("PDF generation error:", err);
  } finally {
   
    if (footer) footer.style.display = "flex"; 
  }
};

  const handlePrint = () => {
  const printContents = document.getElementById("invoice-print-area");

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
      <head>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        <style>
          body { margin: 10px; }
        </style>
      </head>
      <body></body>
    </html>
  `);

  printWindow.document.close();

  // ✅ Clone exact node (keeps structure better)
  const clonedContent = printContents.cloneNode(true);
  printWindow.document.body.appendChild(clonedContent);

  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

   const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

        warrantyDetail(
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };
  return (
    <>
      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>Warranty</h3>
          <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
            <div class="col-12 col-md-4">
              <input
                type="text"
                class="form-control"
                id="searchInput"
                placeholder="Search..."
                      value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button className='btn btn-success' onClick={handleAddClick} >
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>
          {showForm && (
            <form onSubmit={handleUpdate}>


              <div className='card p-3 my-3 shadow-sm bg-white border'>
                <div className='row'>

                  <div className='col-12'>
                                                                {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`WTY/${formItems.id}/${branchDetail.code}`}
    </span>
  </div>
)}
                    <div className='row g-3'>

                      <div className="col-12 col-md-4">
                        <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose Party..."
                          value={formItems.partyName || ""}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                          required
                        />

                        <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>Search Party</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form.Control
                              type="text"
                              placeholder="Search by name, phone, or address"
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                                 ref={searchInputRef}
                            />
                            <div className="table-responsive mt-3">
                              <Table striped bordered hover className="mt-3">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filtered.map((p) => (
                                    <tr key={p.value}>
                                      <td>{p.label}</td>
                                      <td>{p.phone}</td>
                                      <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                        {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                      </td>
                                      <td className="text-center" style={{ width: "80px" }}>

                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={() => {

                                            setFormItems((prev) => ({
                                              ...prev,
                                              party: p.value,
                                              partyName: p.label,
                                              ref_doc: null,
                                              ref_doc_sq: null
                                            }));
                                            const filteredInvoices = allSaleInvoices.filter(inv => {
                                              if (String(inv.party) !== String(p.value)) return false;
                                              const alreadyUsed = fetchWarranty.some(
                                                w =>
                                                  w.ref_doc === inv.ref_doc ||
                                                  (w.ref_doc === inv.ref_doc_sq && inv.ref_doc_sq)
                                              );
                                             return !alreadyUsed;
                                            });
                                       setRefDocs(
                                              filteredInvoices.map(q => ({
                                                value: q.ref_doc_sq || q.ref_doc,
                                                label: q.inv_no
                                                  ? `SL: ${q.inv_no}`
                                                  : `SL: ${q.ref_doc_sq || q.ref_doc}`,
                                                ref_doc: q.ref_doc,
                                                ref_doc_sq: q.ref_doc_sq || null
                                              }))
                                            );
                                            setShowPartyModal(false);
                                          }}
                                        >
                                          Select
                                        </Button>

                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div>


                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Ref Doc.</label>
                        <Select
                          placeholder="Choose Ref Doc..."
                          options={refDocs}
                          value={selectedDoc}
                          onChange={handleSelectDoc}
                          isDisabled={isEditMode}
                        />
                      </div>


                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium"> Date </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="created_date"
                          value={
                            formItems.created_date
                          }
                          onChange={handleChange}
                        />
                      </div>


                      <div className="col-12 col-sm-12 col-md-4">
                        <label className="form-label fw-medium">Sale Person</label>
                        <Select
                          options={user.map((t) => ({
                            value: t.id,
                            label: `${t.first} ${t.last} (${t.emp_id})`,
                          }))}


                          value={
                            user
                              .map((t) => ({
                                value: t.id,
                                label: `${t.first} ${t.last} (${t.emp_id})`,
                              }))
                              .find((opt) => opt.value == formItems.sale_person) || null
                          }
                          onChange={(e) =>
                            handleChange({ target: { name: "sale_person", value: e.value } })
                          }
                          className="w-100"
                          menuPlacement="auto"
                        />

                      </div>

                      <div className="col-12 col-sm-12 col-md-4">
                        <label className="form-label fw-medium">Technician</label>

                        <Select
                          options={user.map((t) => ({
                            value: t.id,
                            label: `${t.first} ${t.last} (${t.emp_id})`,
                          }))}


                          value={
                            user
                              .map((t) => ({
                                value: t.id,
                                label: `${t.first} ${t.last} (${t.emp_id})`,
                              }))
                              .find((opt) => opt.value == formItems.technician) || null
                          }

                          onChange={(e) =>
                            handleChange({ target: { name: "technician", value: e.value } })
                          }
                          className="w-100"
                          menuPlacement="auto"
                        />


                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Start Date </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="start_date"
                          value={formItems.start_date}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">End Date </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="end_date"
                          value={formItems.end_date}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-12 col-md-4">
                        <label className="form-label fw-medium">Items:</label>

                        <Select
                          options={items.map((t) => ({
                            value: t.id,
                            label: `${t.name} (${t.stock})`,
                          }))}

                          value={
                            selectedItemId
                              ? {
                                value: selectedItemId,
                                label:
                                  items.find((i) => i.id === selectedItemId)?.name +
                                  " (" +
                                  items.find((i) => i.id === selectedItemId)?.stock +
                                  ")",
                              }
                              : null
                          }

                          onChange={(e) =>
                            handleSelectChange({
                              target: { name: "emp_id", value: e?.value || "" },
                            })
                          }

                          className="w-100"
                          menuPlacement="auto"
                        />
                      </div>

                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="table-primary">
                          <tr>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th>Item  Rate</th>
                            <th>Sr No.</th>
                            <th>Installed In</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center text-muted">
                                Select an item from the dropdown to add here
                              </td>
                            </tr>
                          ) : (
                            formData.map((fi, idx) => (
                              <tr key={idx}>
                                <td><input type="text" className="form-control" value={fi.name} onChange={(e) => handleFormItemChange(idx, "name", e.target.value)} /></td>
                                <td><input type="number" className="form-control" value={fi.qty} onChange={(e) => handleFormItemChange(idx, "qty", e.target.value)} /></td>
                                <td><input type="number" className="form-control" value={fi.rate} onChange={(e) => handleFormItemChange(idx, "rate", e.target.value)} /></td>

                                <td
                                ><input type="text" className="form-control"
                                //  value={fi.sr_no}
                                  value={getSerialNumbers(fi.id, fi.qty).join(", ")}
                                  onChange={(e) => handleFormItemChange(idx, "sr_no", e.target.value)} />
                                  
                                  
                                    </td>

                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={fi.install}
                                    onChange={(e) => handleFormItemChange(idx, "install", e.target.value)}
                                  />
                                </td>


                                <td><input type="text" className="form-control" value={fi.amount || ""} readOnly /></td>
                                <td>
                                  <button className="btn btn-danger" onClick={() => handleDeleteItem(idx)}>Delete</button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        <tfoot>




                          <tr>
                            <td colSpan="6" className="text-end fw-bold">Total</td>
                            <td>
                              {/* <input type="text"
                                value={isEditMode ? formItems.total : grandTotal}

                                readOnly className="form-control" /> */}
                              <input
                                type="text"
                                className="form-control"
                                value={grandTotalState}
                                readOnly
                              />

                            </td>

                          </tr>



                        </tfoot>
                      </table>
                    </div>
                  </div>

                  <div className='col-12 col-md-6 p-3'>
                    <label className='form-label fw-medium'>Attachment</label>
                    <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange} />
                    {isEditMode && files.file && typeof files.file === "string" && (
                      <div className="mt-2">
                        <span>Previous file: </span>
                        <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                      </div>
                    )}
                  </div>


                  <div className='col-12 col-md-6 p-3'>
                    <label>Service Frequency</label>
                    <Select
                      options={frequencyOptions}
                      placeholder="Select frequency"
                      name='frequency'
                      value={frequencyOptions.find(o => o.value === formItems.frequency)}
                      onChange={handleFrequencyChange}
                      isDisabled={isEditMode}
                    />
                  </div>


                  <div className='col-12 col-md-6 p-3'>

                    {pmsSchedule.length > 0 && (
                      <table className='table table-bordered text-center align-middle mt-3'>
                        <thead>
                          <tr className="table-primary">
                            <th>PMS No.</th>
                            <th>Due Date</th>
                            <th>Completion Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pmsSchedule.map((item) => (
                            <tr key={item.pmsNo}>
                              {/* <td>{item.pmsNo}</td> */}
                              <td>{`PMS/${item.pmsNo}/${branchDetail.code}`}</td>
                              <td>{item.dueDate}</td>
                              <td>{item.completionDate}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>


                  <div className='row' >
                    <div className="col-12 col-md-6 p-3">
                      <label>Type</label>
                      <select
                        className="form-control"
                        name="warranty_type"
                        value={formItems.warranty_type || ""}
                        onChange={(e) => handleTypeSelect(e)}
                      >
                        <option value="">-- Select Type --</option>

                        {typeOptions.map((type, i) => (
                          <option key={i} value={type}>{type}</option>
                        ))}

                        <option value="__add_new_type__">➕ Add New Type</option>
                      </select>
                    </div>


                    {showTypeModal && (
                      <div className="modal show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                          <div className="modal-content">

                            <div className="modal-header">
                              <h5 className="modal-title">Add New Type</h5>
                              <button
                                className="btn-close"
                                onClick={() => setShowTypeModal(false)}
                              />
                            </div>

                            <div className="modal-body">
                              <input
                                type="text"
                                className="form-control"
                                value={newTypeName}
                                onChange={(e) => setNewTypeName(e.target.value)}
                              />
                            </div>

                            <div className="modal-footer">
                              <button
                                className="btn btn-secondary"
                                onClick={() => {
                                  setShowTypeModal(false);
                                  setNewTypeName("");
                                }}
                              >
                                Cancel
                              </button>

                              <button
                                className="btn btn-success"
                                onClick={() => {
                                  if (!newTypeName.trim()) return;

                                  setTypeOptions(prev => [...prev, newTypeName]);

                                  setFormItems(prev => ({
                                    ...prev,
                                    warranty_type: newTypeName,
                                    remark: ""
                                  }));

                                  setNewTypeName("");
                                  setShowTypeModal(false);
                                }}
                              >
                                OK
                              </button>
                            </div>

                          </div>
                        </div>
                      </div>
                    )}

                    <div className='col-12 col-md-6 p-3'>
                      <label className='form-label fw-medium'>Remark</label>
                      <textarea className='form-control w-100' rows="5" name='remark' value={formItems.remark} onChange={handleChange}></textarea>
                    </div>
                  </div>



                  <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                    <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                    <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                  </div>
                </div>
              </div>


            </form>
          )}


          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>
              <thead className='table-info'>
                <tr>
                    <th scope='col' >Action</th>
                  <th scope='col' >Doc No. </th>
                  <th scope='col'>Party Name</th>
              
                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>

                  <th scope='col'>Edit By</th>

                  <th scope='col'>Edit Date</th>

               
                </tr>
              </thead>
              <tbody>
                {filteredData.map((p, i) => (
                  <tr key={p.id}>
                    {/* <td>{i + 1}</td> */}
                        <td>

                      <button
                        className="btn btn-success"

                        onClick={() => handleEdit(p)}
                      >
                        <CiEdit size={20} />
                      </button>
                       <button
                        className="btn btn-warning mx-1"

                        onClick={() => {
    setSelectedWarranty(p);
    setShowWarrantyModal(true);
  }}
                      >
                        <BiMessageAltMinus size={20} />
                      </button>
                    </td>
                    <td>{`WTY/${p.id}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>

                    <td>{p.party_name}</td>
                    <td>{p.added_name} {p.added_name_middle} {p.added_name_last} </td>
                    <td>{p.created_date}  </td>
                    <td>{p.edit_name} {p.edit_name_middle} {p.edit_name_last} </td>
                    <td>{p.edit_date} </td>

                
                  </tr>
                ))}
              </tbody>



{showWarrantyModal && selectedWarranty && (
  <div className="modal fade show d-block" tabIndex="-1">
    <div className="modal-dialog modal-lg">
      <div className="modal-content" id="warranty-letter">
        {/* ====== PRINT TEMPLATE INSIDE MODAL ====== */}
        <div
          style={{
            padding: "50px",
            fontFamily: "Times New Roman",
            lineHeight: "1.5",
            width: "100%",
            background: "linear-gradient(to bottom, #f6f9ff, #eef3ff)",
            position: "relative",
          }}
        >
          {/* WATERMARK */}
          <img
            src={logo}
            alt="watermark"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "350px",
              height: "350px",
              opacity: "0.08",
              transform: "translate(-50%, -50%)",
              zIndex: "0",
            }}
          />

          <div style={{ position: "relative", zIndex: "10", textAlign: "left" }}>
            {/* HEADER */}
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              <u>Warranty Letter</u>
            </h2>

            {/* DATE */}
            <div style={{ textAlign: "left", marginBottom: "20px" }}>
              <b>Date:</b> {new Date().toLocaleDateString()}
            </div>

            {/* PARTY DETAILS */}
            <p>
              To,<br />
              <b>{selectedWarranty.party_name}</b><br />
              {selectedWarranty.party_address}
            </p>

            {/* GREETING */}
            <p><b>Dear {selectedWarranty.party_name?.split(" ")[0]},</b></p>

            {/* BODY */}
            <p>
              Thank you for purchasing from <b>Star Signature Services</b>. We are pleased to provide the details of your machine(s) and warranty below:
            </p>

            {/* MACHINE/ITEM DETAILS */}
            <ul style={{ paddingLeft: "20px" }}>
              {selectedWarranty.items && JSON.parse(selectedWarranty.items).map((item, idx) => {
                let srNo = [];
                try {
                  srNo = typeof item.sr_no === "string" ? JSON.parse(item.sr_no) : item.sr_no;
                } catch (err) {
                  srNo = item.sr_no || [];
                }

                return (
                  <li key={idx} style={{ marginBottom: "10px" }}>
                    <b>Machine Name:</b> {item.name}<br />
                    <b>Sr No:</b> {Array.isArray(srNo) ? srNo.join(", ") : srNo}
                  </li>
                );
              })}
              {/* <li style={{ marginBottom: "10px" }}><b>Invoice No:</b> {selectedWarranty.sale_invoice_no}</li> */}
              <li><b> Date:</b> {selectedWarranty.created_date}</li>
            </ul>

            {/* WARRANTY DETAILS */}
            <p>
              Your unit has been successfully commissioned as per our commissioning report. Warranty is valid for <b>12 months from commissioning</b> or <b>13 months from delivery</b>, whichever is earlier.
            </p>

            <p>
              During the warranty period, <b>{selectedWarranty.frequency}</b> services will be provided.
            </p>

            <p>
              We thank you for your trust and assure you of our best services always.
            </p>

            {/* SIGNATURE */}
            <br /><br />
            <p><b>Regards,</b></p>
            <p><b>Authorized Signatory</b></p>
            <p><b>Star Signature Services</b></p>
          </div>
        </div>

        {/* MODAL FOOTER */}
        <div className="modal-footer no-print">
          <button
            className="btn btn-secondary"
            onClick={() => setShowWarrantyModal(false)}
          >
            Close
          </button>
          <button
            className="btn btn-success"
            onClick={downloadWarrantyPDF}
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
)}
            </table>
          </div>
  {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}


        </div>
      </div>

    </>
  )
}

export default Warranty 